import { Action } from '@ngrx/store';
import { SiteSettings } from './../../../shared/models/site-settings';
import { StrataResponse } from '../../../shared/models/strata-response';

export enum UIActionTypes {
  SET_LOGIN_CHECK_COMPLETE = '[UI] Set Login Check Complete',
  SET_IS_LOGGED_IN_TRUE = '[UI] Set Is Logged In True',
  SET_IS_LOGGED_IN_FALSE = '[UI] Set Is Logged In False',
  SET_SUB_DOMAIN = '[UI] Set Sub Domain',
  SET_STRATA_PLAN_FRIENDLY_NAME = '[UI] Set Strata Plan Friendly Name',
  FETCH_LOTS_AND_UNITS = '[UI] Fetch Lots and Units',
  FETCH_LOTS_AND_UNITS_SUCCESS = '[UI] Fetch Lots and Units Success',
  FETCH_LOTS_AND_UNITS_FAILURE = '[UI] Fetch Lots and Units Failure',
  FETCH_LOTS_AND_UNITS_WITH_STRATA_PLAN = '[UI] Fetch Lots and Units With Strata Plan Number',
  FETCH_LOTS_AND_UNITS_WITH_STRATA_PLAN_FAILURE = '[UI] Fetch Lots and Units With Strata Plan Number Failure',
  FETCH_LOTS_AND_UNITS_WITH_STRATA_PLAN_SUCCESS = '[UI] Fetch Lots and Units With Strata Plan Number Success',
  FETCH_SITE_SETTINGS = '[UI] Fetch Site Settings',
  FETCH_SITE_SETTINGS_SUCCESS = '[UI] Fetch Site Settings Success',
  FETCH_SITE_SETTINGS_FAILURE = '[UI] Fetch Site Settings Failure',
  APPROVER_USER_LOGIN = '[UI] APPROVER_USER_LOGIN',
  SEARCHER_USER_LOGIN = '[UI] Searcher_User_Login',
  LOAD_ACTION_STATUS = '[UI] Load Action Status',
  LOAD_ACTION_STATUS_SUCCESS = '[UI] Load Action Status Success'
}

export class FetchSiteSettings implements Action {
  readonly type = UIActionTypes.FETCH_SITE_SETTINGS;
  constructor(public payload: StrataResponse) { } // strataPlanNumber
}

export class FetchSiteSettingsSuccess implements Action {
  readonly type = UIActionTypes.FETCH_SITE_SETTINGS_SUCCESS;
  constructor(public payload: SiteSettings) { }
}

export class FetchSiteSettingsFailure implements Action {
  readonly type = UIActionTypes.FETCH_LOTS_AND_UNITS_FAILURE;
  constructor(public payload: string) { }
}


export class SetLoginCheckComplete implements Action {
  readonly type = UIActionTypes.SET_LOGIN_CHECK_COMPLETE;
}

export class SetSubDomain implements Action {
  readonly type = UIActionTypes.SET_SUB_DOMAIN;
  constructor(public payload: string) { }
}

export class SetStrataPlanFriendlyName implements Action {
  readonly type = UIActionTypes.SET_STRATA_PLAN_FRIENDLY_NAME;
  constructor(public payload: string) { }
}

export class FetchLotsAndUnits implements Action {
  readonly type = UIActionTypes.FETCH_LOTS_AND_UNITS;
  constructor(public payload: string) { } // plan number
}

export class FetchLotsAndUnitsSuccess implements Action {
  readonly type = UIActionTypes.FETCH_LOTS_AND_UNITS_SUCCESS;
  constructor(public payload: StrataResponse) { }
}

export class FetchLotsAndUnitsFailure implements Action {
  readonly type = UIActionTypes.FETCH_LOTS_AND_UNITS_FAILURE;
  constructor(public payload: string) { }
}


export class ApproverSetIsApprover implements Action {
  readonly type = UIActionTypes.APPROVER_USER_LOGIN;
}

export class SetIsSearcher implements Action {
  readonly type = UIActionTypes.SEARCHER_USER_LOGIN;
}

export class FetchLotsAndUnitsWithStrataPlan implements Action {
  readonly type = UIActionTypes.FETCH_LOTS_AND_UNITS_WITH_STRATA_PLAN;
}

export class FetchLotsAndUnitsWithStrataPlanSuccess implements Action {
  readonly type = UIActionTypes.FETCH_LOTS_AND_UNITS_WITH_STRATA_PLAN_SUCCESS;
  constructor(public payload: StrataResponse) { }
}

export class FetchLotsAndUnitsWithStrataPlanFailure implements Action {
  readonly type = UIActionTypes.FETCH_LOTS_AND_UNITS_WITH_STRATA_PLAN_FAILURE;
  constructor(public payload: string) { }
}


export class SetIsLoggedInTrue implements Action {
  readonly type = UIActionTypes.SET_IS_LOGGED_IN_TRUE;
}

export class SetIsLoggedInFalse implements Action {
  readonly type = UIActionTypes.SET_IS_LOGGED_IN_FALSE;
}


export class LoadActionStatus implements Action {
  readonly type = UIActionTypes.LOAD_ACTION_STATUS;
  constructor(public payload: any) { }
}

export class LoadActionStatusSuccess implements Action {
  readonly type = UIActionTypes.LOAD_ACTION_STATUS_SUCCESS;
  constructor(public payload: any) { }
}

export type UIActions = SetLoginCheckComplete
  | SetSubDomain
  | SetStrataPlanFriendlyName
  | SetIsLoggedInTrue
  | SetIsLoggedInFalse
  | FetchLotsAndUnits
  | FetchLotsAndUnitsSuccess
  | FetchLotsAndUnitsFailure
  | FetchLotsAndUnitsWithStrataPlan
  | FetchLotsAndUnitsWithStrataPlanSuccess
  | FetchLotsAndUnitsWithStrataPlanFailure
  | FetchSiteSettings
  | FetchSiteSettingsSuccess
  | FetchSiteSettingsFailure
  | ApproverSetIsApprover
  | SetIsSearcher
  | LoadActionStatus
  | LoadActionStatusSuccess;
